<template>
  <div>
    <el-container class="home-container">
      <el-header class="home-header">
        <span class="home_title">Algae-Hub 后台管理系统</span>
        <div style="display: flex;align-items: center;margin-right: 7px">
          <el-dropdown @command="handleCommand">
  <span class="el-dropdown-link home_userinfo" style="display: flex;align-items: center">
    {{ user.name }}
    <i><img :src="imgPrefix+user.userface"
            alt=""
            style="width: 40px;height: 40px;margin-right: 5px;margin-left: 15px;border-radius: 40px"
            v-if="user.userface!==''"/></i>
  </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout" divided>注销</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-container>
        <el-menu :collapse="collapse"
                 :style="{ width: (collapse ? 64 : 220) + 'px' }"
                 :unique-opened="true"
                 class="home-aside"
                 router>
          <template v-for="(item,index) in this.routes" v-if="!item.hidden">
            <el-submenu :index="index+''" :key="index">
              <template slot="title">
                <i :class="[item.iconCls, 'aside-menu-icon']"></i>
                <span slot="title">{{ item.name }}</span>
              </template>
              <el-menu-item :index="child.path"
                            :key="child.path"
                            v-for="child in item.children">{{ child.name }}
              </el-menu-item>
            </el-submenu>
          </template>
          <div
              class="aside-collapse-area">
            <el-button :icon="collapse ? 'el-icon-d-arrow-right':'el-icon-d-arrow-left'"
                       @click="collapse = !collapse"
                       :title="collapse ? '展开菜单' : '收起菜单'"
                       class="aside-collapse-toggle"></el-button>
          </div>
        </el-menu>
        <el-main style="max-height: calc(100vh - 60px);overflow-y: scroll;">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-text="this.$router.currentRoute.name"></el-breadcrumb-item>
          </el-breadcrumb>
          <keep-alive>
            <router-view v-if="this.$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!this.$route.meta.keepAlive"></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
export default {
  mounted: function () {
  },
  methods: {
    handleCommand(cmd) {
      var _this = this;
      if (cmd === 'logout') {
        this.$confirm('注销登录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.getRequest("/admin/api/sys/logout");
          _this.$store.commit('logout');
          _this.$router.replace({path: '/'});
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '取消'
          });
        });
      }
    }
  },
  data() {
    return {
      isDot: false,
      imgPrefix: this.adminApi.default.imgPrefix,
      collapse: false
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    routes() {
      return this.$store.state.routes
    }
  }
}
</script>
<style>
.home-container {
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.home-header {
  background: #fff;
  border-bottom: 1px solid #e8eaed;
  box-shadow: none;
  color: #1c2126;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: content-box;
  padding: 0;
}

.home-aside {
  background: #fff;
  border-right: 1px solid #e8eaed;
  box-shadow: none;
  text-align: left;
  position: relative;
  max-height: calc(100vh - 60px);
  overflow-y: scroll;
}

.home-main {
  background-color: #fff;
  color: #000;
  text-align: center;
  margin: 0;
  padding: 0;;
}

.home_title {
  color: #1c2126;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 1px;
  display: inline-flex;
  align-items: center;
  margin-left: 20px;
}

.home_title::before {
  content: '';
  width: 7px;
  height: 24px;
  margin-right: 10px;
  border-radius: 8px;
  background: #003983;
}

.home_userinfo {
  color: #1c2126;
  font-weight: 500;
  cursor: pointer;
}

.home_userinfoContainer {
  display: inline;
  margin-right: 20px;
}

.home-aside .el-menu {
  background: transparent !important;
  border-right: 0;
}

.home-aside .el-submenu__title {
  height: 52px;
  line-height: 52px;
  color: #1c2126;
  font-weight: 400;
  transition: all 0.2s ease;
}

.home-aside .el-submenu__title:hover {
  background: #fff !important;
  color: #003983;
}

.home-aside .el-submenu .aside-menu-icon,
.home-aside .el-submenu .el-submenu__icon-arrow {
  color: #828d99 !important;
}

.home-aside .el-submenu__title:hover .aside-menu-icon,
.home-aside .el-submenu__title:hover .el-submenu__icon-arrow {
  color: #003983 !important;
}

.home-aside .el-submenu.is-active > .el-submenu__title,
.home-aside .el-submenu.is-active > .el-submenu__title .aside-menu-icon,
.home-aside .el-submenu.is-active > .el-submenu__title .el-submenu__icon-arrow {
  color: #003983 !important;
}

.home-aside .el-menu-item {
  width: calc(100% - 14px);
  min-width: 0;
  height: 46px;
  line-height: 46px;
  margin-left: 14px;
  box-sizing: border-box;
  color: #1c2126;
  background: transparent !important;
  transition: all 0.2s ease;
}

.home-aside .el-menu-item:hover {
  color: #003983;
  background: #fff !important;
}

.home-aside .el-menu-item.is-active {
  position: relative;
  color: #003983;
  font-weight: 600;
  background: #eaf2ff !important;
  border-radius: 0;
}

.aside-collapse-area {
  display: flex;
  justify-content: center;
  align-items: center;
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 54px;
  padding: 8px;
  box-sizing: border-box;
  background: #fff;
  border-top: 1px solid #e8eaed;
}

.aside-collapse-toggle {
  width: 36px;
  height: 32px;
  padding: 0;
  color: #828d99;
  background: #ffffff;
  border-color: #e8eaed;
  border-radius: 4px;
  box-shadow: none;
  transition: all 0.2s ease;
}

.aside-collapse-toggle:hover {
  color: #003983;
  background: #f6f6f6;
  border-color: #f6f6f6;
  transform: none;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue